'use strict';

var _ = require('lodash');
var BidPriceChartDataProviderService = function BidPriceChartDataProviderService(dataRetrieverService, constants, colorScales, SearchCriteriaRule) {
  var colors = colorScales.colorScale1();
  var dataRetriever = dataRetrieverService.getDataRetriever(constants.MARKET_SCREEN, constants.CABIN_DEEP_MODE);
  function getLegsIds(serviceId) {
    return serviceId.split('|');
  }
  function getCabinCodes(associatedLegCabins) {
    return _.chain(associatedLegCabins).map(function (c) {
      return c.split('.').reverse()[0];
    }).uniq().value();
  }
  function retrieveData(serviceId, associatedLegCabins) {
    var rules = [],
      legsIds = getLegsIds(serviceId),
      cabinCodes = getCabinCodes(associatedLegCabins),
      rule;
    for (var i = 0, length = legsIds.length; i < length; i++) {
      rule = new SearchCriteriaRule({
        field: 'legs.legId',
        operator: '='
      });
      rule.leftOperand = legsIds[i];
      rules.push(rule);
    }
    for (var j = 0, cabinsLength = cabinCodes.length; j < cabinsLength; j++) {
      rule = new SearchCriteriaRule({
        field: 'legs.legCabins.cabinCode',
        operator: '='
      });
      rule.leftOperand = cabinCodes[j];
      rules.push(rule);
    }
    return dataRetriever.localSortApplied().retrieveData('bid-price-chart', rules);
  }
  function filterLegCabin(selectedLegCabin, data) {
    var legCabinData = _.find(data, {
      leg: selectedLegCabin.leg,
      cabinCode: selectedLegCabin.cabinCode
    });
    if (legCabinData) {
      legCabinData.fill = colors(0);
      legCabinData.dotted = false;
      return [legCabinData];
    }
    return [];
  }
  function getDataForLeg(serviceId, associatedLegCabins, selectedLegCabin) {
    return retrieveData(serviceId, associatedLegCabins).then(filterLegCabin.bind(null, selectedLegCabin));
  }
  return {
    getData: getDataForLeg
  };
};
BidPriceChartDataProviderService.$inject = ['DataRetrieverService', 'DataRetrieverConstantsService', 'RmColorScales', 'SearchCriteriaRuleFactory'];
module.exports = BidPriceChartDataProviderService;